import React, { useState, useEffect, useContext } from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import { authorization } from 'Module/Auth/Auth'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { updateUserById, getUserById } from 'Reducers/Users/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { PATHS } from 'Config/Routing/paths'
import { ProfileInfo } from './ProfileInfo'
import { ProfileEditForm } from './ProfileEditForm'
import { styles } from './styles'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'
import { UserManagementIcon } from '../../Assets/Images/icons/UserManagementIcon'
import classNames from 'classnames'
import { SocialLink } from './components/SocialLink/SocialLink'
import { CreateResetPassword } from './components/CreateResetPassword/CreateResetPassword'
import { SnackBarContext } from '../../Components/SnackBar'

const useStyles = makeStyles(() => styles)

const ProfilePage = () => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const [edit, setEdit] = useState(false)
  const [user, setUser] = useState(authorization.getUser())
  const [saving, setSaving] = useState(false)
  const runSnackBar = useContext(SnackBarContext)

  const openSnackBar = (type, message) => {
    runSnackBar({
      type: type,
      vertical: 'top',
      msg: message,
      autoHideDuration: 6000,
      key: new Date().getTime(),
    })
  }

  useEffect(() => {
    const handleStorageChange = () => {
      setUser(authorization.getUser())
    }

    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  useEffect(() => {
    const handleStorageEvent = event => {
      if (event.key === 'social_merge_trigger') {
        const success = localStorage.getItem('social_merge_success')
        if (success === 'false') {
          openSnackBar(
            'error',
            "The Google email you're using doesn't match the one registered in your account.",
          )
        } else if (success === 'true') {
          openSnackBar('success', 'Accounts successfully linked')
        }
      }
    }

    window.addEventListener('storage', handleStorageEvent)
    return () => {
      window.removeEventListener('storage', handleStorageEvent)
    }
  }, [])

  const handleProfileEditFormSubmit = newUserData => {
    if (JSON.stringify(newUserData) === JSON.stringify(user)) {
      // if nothing changed just go back to user profile
      setEdit(!edit)
    }
    setSaving(true)
    const imageFile = newUserData.profilePicture
    const callbacks = {
      onSuccess: () => {
        dispatch(getUserById(user.id))
        handleProfileEditEditFormSuccess()
        setEdit(!edit)
        setSaving(false)
      },
    }
    const payload = imageUrl => ({
      profile_picture: imageUrl,
      first_name: newUserData.firstName,
      last_name: newUserData.lastName,
      mobile_phone: newUserData.mobilePhone,
      client_id: user.client ? user.client.id : null,
    })

    if (imageFile.type) {
      dispatch(
        uploadProfileImage(user.id, imageFile, {
          onSuccess: imageUrl => {
            dispatch(updateUserById(user.id, payload(imageUrl), callbacks))
          },
        }),
      )
    } else {
      dispatch(updateUserById(user.id, payload(), callbacks))
    }
  }

  const handleProfileEditEditFormSuccess = () => {
    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.profile}`)
  }

  return (
    <div
      className={classNames(
        classes.profileContainer,
        'makeStyles-profileContainer',
      )}
    >
      <StyledBreadcrumbs
        icon={<UserManagementIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.profile}`,
            label: 'Profile',
          },
        ]}
      />
      <Typography className={classes.profileTitle} cypress_id={'profileTitle'}>
        Profile Details
      </Typography>
      <div
        className={classNames(
          classes.profileContent,
          'makeStyles-profileContent',
        )}
      >
        {!edit ? (
          <ProfileInfo user={user} edit={edit} setEdit={setEdit} />
        ) : (
          <ProfileEditForm
            user={user}
            edit={edit}
            setEdit={setEdit}
            handleSave={handleProfileEditFormSubmit}
            saving={saving}
          />
        )}
      </div>
      <Typography className={classes.profileTitle} cypress_id={'profileTitle'}>
        Security
      </Typography>
      <div
        className={classNames(
          classes.securityContent,
          'makeStyles-profileContent',
        )}
      >
        <CreateResetPassword user={user} />
        <SocialLink type="Google" user={user} />
      </div>
    </div>
  )
}

export { ProfilePage }
